import { FC } from 'react';
import { BrowserRouter, Navigate, useRoutes } from 'react-router-dom';
import { AuthLayout } from './routes/authLayout';
import { BaseLayout } from './routes/layout';
import { Home } from './routes/page';
import { EnvironmentReportsPage } from './routes/reports/environment/page';
import { ArchiveReportsPage } from './routes/reports/archive/page';
import { Privacy } from './routes/privacy/page';
import { RequestReportPage } from './routes/reports/aggregate/page';
import { ManualInputPage } from './routes/manual-input/page';
import { Roles, useUserContext } from './lib/context';
import { CreateArticlePage } from './routes/content/create-article/page';
import { UpdateArticlePage } from './routes/content/update-article/page';
import { ContentManagementPage } from './routes/content/management/page';
import { ArticleManagementPage } from './routes/content/management/_tabs/articles';
import { GuideManagementPage } from './routes/content/management/_tabs/guides';

const Routes = () => {
  const { roles } = useUserContext();
  const routesConfig = [
    {
      element: <BaseLayout />,
      children: [
        { element: <Home />, path: '/' },
        {
          path: '',
          element: <AuthLayout />,
          children: [
            {
              path: '/reports',
              children: [
                {
                  element: <EnvironmentReportsPage />,
                  path: 'environment',
                },
                {
                  element: <RequestReportPage />,
                  path: 'request',
                },
                {
                  element: <ArchiveReportsPage />,
                  path: 'archive',
                  roles: [Roles.Administrator],
                },
              ],
            },
            {
              path: '/manual-input',
              element: <ManualInputPage />,
              roles: [Roles.Administrator, Roles.Deelnemer, Roles.Dienstverlener, Roles.KeyuserBevoegdgezag],
            },
            {
              path: '/content-management',
              element: <ContentManagementPage />,
              roles: [Roles.Administrator],
              children: [
                { element: <ArticleManagementPage />, path: 'article', roles: [Roles.Administrator] },
                { element: <GuideManagementPage />, path: 'guide', roles: [Roles.Administrator] },
              ],
            },
            {
              path: 'article',
              children: [
                { element: <CreateArticlePage />, path: 'create', roles: [Roles.Administrator] },
                { element: <UpdateArticlePage />, path: 'edit/:id', roles: [Roles.Administrator] },
              ],
            },
          ],
        },

        { path: '/privacy', element: <Privacy /> },
      ],
    },
  ];

  const filterRoutes = (routes, roles) =>
    routes.map(route => {
      if (route.roles && !route.roles.some(role => roles.includes(role))) {
        return { ...route, element: <Navigate to="/" /> };
      }
      if (route.children) {
        return { ...route, children: filterRoutes(route.children, roles) };
      }
      return route;
    });
  const filteredRoutes = filterRoutes(routesConfig, roles);
  return useRoutes(filteredRoutes);
};

export const AppRouter: FC = () => {
  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
};
